import React from 'react';
import { ArticleHeading1, Image } from '@cian/ui-kit';
import { IImages } from '../../../types/newbuildingsCompare';
import * as styles from './styles.css';

export function Content({ images }: { images: IImages[] }) {
  return (
    <div className={styles['container']}>
      <div className={styles['heading']}>
        <ArticleHeading1 as={'h2'}>Галерея</ArticleHeading1>
      </div>
      {images.map(image => (
        <Image key={image.fullUrl} src={image.fullUrl} width="100%" height="auto" objectFit="contain" />
      ))}
    </div>
  );
}
